<template>
  <div id="app">
    <!-- <public-head></public-head> -->
    <el-container>
      <!-- <public-nav></public-nav> -->
      <router-view/>
    </el-container>
<!--    {{isIdle}}-->
  </div>
</template>

<script>

import {endPage} from "@/utils/collectUtil";
import {EventBus} from "@/utils/event-bus";
import {getUUID} from "@/utils/index";

export default {
  name: "App",
    computed: {
        isIdle() {
            let isIdle= this.$store.state.idleVue.isIdle;

            return isIdle;
        }
    },
    watch:{
       isIdle(newValue,oldValue){
           EventBus.$emit("pageIdle",{isIdle:newValue,route:this.$route});
           console.log(newValue);
       }
    },

    mounted() {

     let devId=localStorage.getItem("deviceId");
     if(!devId){
        localStorage.setItem("deviceId",getUUID())
     }
      this.beforeunload=async e => {
          await   endPage(this.$route)
          return  true;
      };
        window.addEventListener('beforeunload', this.beforeunload);
        this.visibilitychange=() => {
            if(document.hidden){
                EventBus.$emit("endPage",this.$route);
            }else{
                EventBus.$emit("startPage",this.$route);
            }

        }
        window.addEventListener('visibilitychange',  this.visibilitychange)
    },

    destroyed() {
      if( this.visibilitychange){
          window.removeEventListener(this.visibilitychange);
      }
      if(this.beforeunload){
          window.removeEventListener(this.beforeunload);
      }
    }
};
</script>

<style scoped lang="scss">
  @import "./styles/mixin.scss";
* {
  margin: 0;
  padding: 0;

}
#app {
  font-family: "Arial Normal", "Arial";
  font-weight: 400;
  font-style: normal;
  font-size: 14px;
  color: #333333;
  /*min-width: 1200px;*/
  min-height: 100vh;
  width: 100%;
}
.el-container{
@include default_bg();
  height:100vh;
  overflow-y:scroll;
  overflow: auto;
  display: flex;
  justify-content: start;
}

</style>



// WEBPACK FOOTER //
// src/App.vue